import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/header";
import Startpage from "./components/startpage";
import { baseRequest } from "./axiosconfig";

import AddEmployeesListPage from "./pages/addEmployeesListPage";
import LoginPage from "./pages/loginPage";
import PoslovniProcesiPage from "./pages/poslovniProcesi";
import FormulareRizikaPage from "./pages/formulareRizikaPage";
import ForgottenPasswordPage from "./pages/forgottenPasswordPage";
import Home from "./components/Home";
import MapeProcesaPage from "./pages/mapeProcesaPage";
import Footer from "./components/Footer";
import SuccessRegistrationPage from "./pages/successRegistrationPage";
import NewStrukturaPreduzeca from "./components/newStrucuraPreduzeca";
import Loading from "./components/loading";
import ContactPage from "./pages/contactPage";
import AdminPage from "./pages/adminPage";
import NotificationsPage from "./pages/notificationsPage";
import FukPage from "./pages/fukPage";
import AdminBusinessProcessesPage from "./pages/adminBusinessProcessesPage";
import AdminStrukturaPreduzecaPage from "./pages/adminStrukturaPreduzecaPage";
import AdminAuthorizationPage from "./pages/adminAuthorizationPage";
import AdminFormulariRizikaPage from "./pages/adminFormulariRizikaPage";
import RegistriRizikaPage from "./pages/registriRizikaPage";
import AdminEmployeesPage from "./pages/adminEmployeesPage";
import AdminMapeProcesaPage from "./pages/adminMapeProcesaPage";
import AdminSingeMapaProcesaPage from "./pages/adminSingleMapaProcesaPage";
import { UnsavedDataContext } from "./context";
import RegisterStrukturaPreduzeca from "./components/registerStrukturaPreduzeca";
import AdminFormulariRizikaSinglePage from "./pages/adminFormulariRizikaSinglePage";
import AdminNewFormularRizikaPage from "./pages/adminNewFormularRizikaPage";
import { useContext } from "react";
import UnsavedDataPopup from "./components/admin/unsavedDataPopup";
import ProtectedRoute from "./components/protectedRoute";
import { UserContext } from "./userContext";
import ArchiveProcessesPage from "./pages/archiveProcessesPage";
import ArchiveMapeProcesaPage from "./pages/archiveMapeProcesaPage";
import ArchiveFormulariRizikaPage from "./pages/archiveFormulariRizikaPage";
import ArchiveEmployeesPage from "./pages/archiveEmployeesPage";
import AdminActivityLogPage from "./pages/adminActivityLogPage";
import SamoprocenaPage from "./pages/samoprocenaPage";
import SamoprocenaSinglePage from "./pages/samoprocenaSinglePage";
import GodisnjiIzvestajPage from "./pages/godisnjiIzvestajPage";
import RegistarKontrolaPage from "./pages/registarKontrolaPage";
import AkcioniPlanoviPage from "./pages/akcioniPlanoviPage";
import IzvestajiPage from "./pages/izvestajiPage";
import ChangePasswordPage from "./pages/changePasswordPage";

function App() {
  const [loading, setLoading] = useState(false);
  const [isLoggedin, setIsloggedin] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { unsavedData, showNavigatePopup, setShowNavigatePopup, navigateUrl } =
    useContext(UnsavedDataContext);

  const { setUser } = useContext(UserContext);

  useEffect(() => {
    setLoading(true);
    baseRequest
      .get("/check-auth")
      .then((res) => {
        setUser(res.data.data);
        setIsloggedin(true);
        setLoading(false);
        if (location.pathname === "/") {
          navigate("/admin/struktura-preduzeca", { replace: true });
        } else {
          navigate(location.pathname, { replace: true });
        }
      })
      .catch(() => {
        // javne strane (registracija, zaboravljena lozinka, kontakt) ostaju
        // dostupne bez prijave — na login se preusmerava samo zaštićeni deo
        if (
          location.pathname.startsWith("/admin") ||
          location.pathname === "/"
        ) {
          navigate("/login", { replace: true });
        }
        setLoading(false);
      });
  }, []);

  return (
    <div className="main-container">
      <Header
        isLoggedin={isLoggedin}
        setIsloggedin={setIsloggedin}
        setLoading={setLoading}
        onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
      />

      <Routes>
        <Route
          path="/"
          element={<Home loading={loading} isLoggedin={isLoggedin} />}
        />
        <Route
          path="/register"
          element={
            <Startpage isLoggedin={isLoggedin} setIsloggedin={setIsloggedin} />
          }
        ></Route>
        <Route
          path="/login"
          element={
            <LoginPage isLoggedin={isLoggedin} setIsloggedin={setIsloggedin} />
          }
        ></Route>
        <Route
          path="/forgotten-password"
          element={<ForgottenPasswordPage />}
        ></Route>
        <Route
          path="/register/struktura-preduzeca"
          element={<NewStrukturaPreduzeca />}
        />
        <Route
          path="/register/spisak-zaposlenih"
          element={<AddEmployeesListPage />}
        />
        <Route
          path="/register/poslovni-procesi"
          element={<PoslovniProcesiPage />}
        />
        <Route
          path="/register/formulari-rizika"
          element={<FormulareRizikaPage />}
        />
        <Route
          path="/register/formulari-rizika/:id"
          element={<FormulareRizikaPage />}
        />

        <Route path="/register/mape-procesa" element={<MapeProcesaPage />} />
        <Route
          path="/register/mape-procesa/:id"
          element={<MapeProcesaPage />}
        />
        <Route
          path="/register/success-registration"
          element={<SuccessRegistrationPage />}
        />
        <Route path="/contact" element={<ContactPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute user={isLoggedin}>
              <AdminPage
                isLoggedin={isLoggedin}
                setIsloggedin={setIsloggedin}
                setLoading={setLoading}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
              />
            </ProtectedRoute>
          }
        >
          <Route path="contact" element={<ContactPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="fuk" element={<FukPage />} />
          <Route
            path="poslovni-procesi"
            element={<AdminBusinessProcessesPage />}
          />
          <Route
            path="struktura-preduzeca"
            element={<AdminStrukturaPreduzecaPage />}
          />
          <Route path="autorizacija" element={<AdminAuthorizationPage />} />
          <Route
            path="formulari-rizika"
            element={<AdminFormulariRizikaPage />}
          />
          <Route
            path="formulari-rizika/:id"
            element={<AdminFormulariRizikaSinglePage />}
          />
          <Route path="registri-rizika" element={<RegistriRizikaPage />} />
          <Route
            path="lista-zaposlenih/:id/:level"
            element={<AdminEmployeesPage />}
          />
          <Route path="mape-procesa" element={<AdminMapeProcesaPage />} />
          <Route
            path="mape-procesa/:id"
            element={<AdminSingeMapaProcesaPage />}
          />
          <Route
            path="formulari-rizika/new"
            element={<AdminNewFormularRizikaPage />}
          />
          <Route
            path="archive-poslovni-procesi"
            element={<ArchiveProcessesPage />}
          />
          <Route
            path="archive-mape-procesa"
            element={<ArchiveMapeProcesaPage />}
          />
          <Route
            path="archive-formulari-rizika"
            element={<ArchiveFormulariRizikaPage />}
          />
          <Route
            path="archive-zaposleni"
            element={<ArchiveEmployeesPage />}
          />
          <Route path="aktivnosti" element={<AdminActivityLogPage />} />
          <Route path="samoprocena" element={<SamoprocenaPage />} />
          <Route
            path="samoprocena/:id"
            element={<SamoprocenaSinglePage />}
          />
          <Route
            path="godisnji-izvestaj"
            element={<GodisnjiIzvestajPage />}
          />
          <Route
            path="registar-kontrola"
            element={<RegistarKontrolaPage />}
          />
          <Route path="akcioni-planovi" element={<AkcioniPlanoviPage />} />
          <Route path="izvestaji" element={<IzvestajiPage />} />
          <Route path="promena-lozinke" element={<ChangePasswordPage />} />
        </Route>
      </Routes>
      <Footer />
      {loading && (
        <div className="loading">
          <Loading isLoading={loading} />
        </div>
      )}

      {showNavigatePopup && (
        <div className="loading">
          <UnsavedDataPopup
            url={navigateUrl}
            setShowNavigatePopup={setShowNavigatePopup}
          />
        </div>
      )}
    </div>
  );
}

export default App;
